module.exports = __webpack_public_path__ + "static/media/logo-grey.8c9a5363.svg";